// extracted by mini-css-extract-plugin
module.exports = {"contentSection":"HelpResponse_contentSection__ngIUv","contentCardSection":"HelpResponse_contentCardSection__auJ1E","faqSection":"HelpResponse_faqSection__AiLgG"};